import { render, staticRenderFns } from "./ModalFavoriteAddressV2.vue?vue&type=template&id=5146b342&scoped=true&"
import script from "./ModalFavoriteAddressV2.vue?vue&type=script&lang=js&"
export * from "./ModalFavoriteAddressV2.vue?vue&type=script&lang=js&"
import style0 from "./ModalFavoriteAddressV2.vue?vue&type=style&index=0&id=5146b342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5146b342",
  null
  
)

export default component.exports